import request from '../../util/request'
import formUtils from '../../util/formUtils'
import alertUtils from '../../util/alertUtils'
import { config } from '../../config/config'

/**
 * 文件/图片 操作接口
 */
export default class fileApi extends alertUtils {
  /**
   * 文件下载
   * @param id 文件id
   */
  static fileDeleted(id) {
    if (formUtils.isNotNull(id)) {
      return request({
        url:
          config.fileBaseAPI +
          '/api/v1/file/service/file-upload/delete?id=' +
          id,
        method: 'DELETE',
      })
    } else {
      this.alertWarning('接口参数不能为空', true)
    }
  }
}
